var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIntelesafetyS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19973 16.8C3.39973 16.7 2.09973 15.1 2.19973 13.5C2.29973 11.9 3.59973 10.6 5.29973 10.5C4.99973 8.70003 5.59973 7.00003 6.99973 6.20003C9.19973 4.90003 11.7997 5.60003 12.9997 7.80003C14.0997 7.10003 15.6997 7.10003 16.6997 7.90003C18.0997 9.00003 17.9997 10.3 17.9997 10.8C19.5997 11 20.4997 12.1 20.6997 13.5C20.6997 13.8 20.6997 14 20.6997 14.3C20.4997 15.8 19.1997 16.8 17.6997 16.8C13.5997 16.9 9.39973 16.8 5.19973 16.8Z",
    fill: "#1487EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIntelesafetyS);
export default __webpack_public_path__ + "static/media/logo_Intelesafety_s.5a5c54a34b64d05db9311cc932b0a232.svg";
export { ForwardRef as ReactComponent };